import qs from 'qs';
import { makeRequest, fetchBaseUrl } from '../store/providers/Ajax';

export const fetchAuthRoles = async (userId) => {

    const base_url = fetchBaseUrl();

    const payload = qs.stringify({
        userId: userId,
        grant_type: "password",
        client_id: "FM3"
    });

    var response = await makeRequest({
        url: `${base_url}/Token/LoginDetails`,
        method: 'POST',
        payload: payload,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });

    return response;
};

export default fetchAuthRoles;